'use strict'

import EventManager from 'assets/core/js/module/eventManager'
import { PartialsLoadingEvents } from 'assets/themes/campings/js/module/partials'
import { Facets } from 'assets/themes/campings/js/page/product/facets'

export default function (facets: Facets, updatePartials: () => void): void {
  const searchAvailabilityForm = document.getElementById('search-availability-form')
  const filtersForm = document.getElementById('filters-sort')

  const sortAccommodations = (): void => {
    const partialEl = document.querySelector('[data-partial-id="results"]')
    if (partialEl) {
      partialEl.dispatchEvent(new CustomEvent(PartialsLoadingEvents.SHOW))
    }

    facets.sortAccommodations(() => {
      if (partialEl) {
        partialEl.dispatchEvent(new CustomEvent(PartialsLoadingEvents.HIDE))
      }
    })
  }

  if (searchAvailabilityForm !== null) {
    const nightValue = searchAvailabilityForm.querySelector<HTMLSelectElement>('select[name=night]')?.value as string

    if (nightValue !== '') {
      document
        .getElementById('checkInDate')
        ?.setAttribute('data-nights', searchAvailabilityForm.querySelector<HTMLSelectElement>('select[name=night]')?.value as string)
    }

    EventManager.addEvent('search-form', document, 'change', function (e: Event) {
      const target = e.target as HTMLElement
      const detail = (e as CustomEvent).detail as {
        src: string
      }

      if (['accommodations', 'budget'].includes(target.id)) {
        sortAccommodations()
      }

      const idsToUpdate = ['capacity', 'capacity_traveler_selector']

      const nightValue = searchAvailabilityForm.querySelector<HTMLSelectElement>('select[name=night]')?.value as string

      if (target.id === 'night' && nightValue !== '') {
        document
          .getElementById('checkInDate')
          ?.setAttribute('data-nights', searchAvailabilityForm.querySelector<HTMLSelectElement>('select[name=night]')?.value as string)
      }

      if (idsToUpdate.includes(target.id)) {
        if (!detail || (detail && detail.src !== 'setValues')) {
          setTimeout(function () {
            updatePartials()
          }, 0)
        }
      }
    })
  }

  if (filtersForm !== null) {
    filtersForm.querySelectorAll('input[name^="accommodation_filters"]').forEach(function (el) {
      EventManager.addEvent('search-form', el, 'change', function () {
        sortAccommodations()

        const scrollTo = <HTMLElement>document.getElementById('booking')
        scrollTo.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'smooth',
        })
      })
    })
  }
}
